import { Component, OnInit, OnDestroy, ViewChild, ElementRef  }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import {GrowthRatesSaveService} from './growth-rates-save/growth-rates-save.service';
import {SetHubSizesService} from './set-hub-sizes/set-hub-sizes.service';
import { UserSession } from '../../shared/user-session';
import { UserInfoService } from '../../shared/user-info.service';
import { IScenario, ScenarioService } from '../../scenario-activities/scenario.service';

@Component({
    //templateUrl: 'app/system-management/growth-rates/growth-rates.component.html',
    template: require('./growth-rates.component.html'),
    styles: [require('../../styles/faa_styles.css')],
    directives: [ROUTER_DIRECTIVES],
    providers: [GrowthRatesSaveService, SetHubSizesService]
    
})

export class GrowthRatesComponent implements OnInit, OnDestroy{
    pageTitle: string = 'Growth Rate';
    errorMessage: string;
    allScenarios: IScenario[];
    scenarioHeaderDiv: HTMLDivElement;
    isScenarioOwner: boolean = false;
    currentScenario: IScenario;

    constructor(private route: ActivatedRoute,
                private router: Router,             
                private _scenarioService: ScenarioService,
                private User: UserSession,
                private _userInfoService: UserInfoService) {
                    
    }
    @ViewChild('scenarioHeader') scenarioHeader: ElementRef;

    ngOnInit(): void{
        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
        this._scenarioService.getScenarios(this.User.getSession()['id'])
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
                () => {
                    this.setScenarioHeader(this.User.getSession().scenarioId);
                }
            );
        
        //this probably needs to be somewhere more central
        this.User.updateSessionState();
        
        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(
            success => this.isScenarioOwner = success.isOwner,
            error => this.errorMessage = <any>error
        );
    }
    private setScenarioHeader(scenarioId: number):void {
        let foundScenarios:IScenario[] = this.allScenarios.filter(function(scenario){
            return scenario.id === scenarioId;
        });
        if(foundScenarios.length > 0){
            this.currentScenario = foundScenarios[0];
        }
        this.scenarioHeaderDiv.innerHTML = `<strong>Current Scenario: ${this.currentScenario.scenarioName} (${this.currentScenario.id})</strong>`;
    }
    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}


/** WEBPACK FOOTER **
 ** ./app/system-management/growth-rates/growth-rates.component.ts
 **/